module.exports = __webpack_public_path__ + "img/Dr. Laura Jane Harper, first dean of women.47b7d5b4.jpg";